import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import Link from '../components/general/Link';
import EdlAllApplications from '../pages/edl/EdlAllApplications';
import EdlAllColleges from '../pages/edl/EdlAllColleges';
import NewEdlCollegeForm from '../forms/NewEdlCollegeForm';
import EdlApplicationPage from '../pages/edl/EdlApplicationPage';

const EducationLoansLayout = ({ match }) => (
  <Fragment>
    <div className="moduleNavBar">
      <Link to={`${match.url}/applications`}>
        <h4 className="moduleNavBarItem">APPLICATIONS</h4>
      </Link>
      <Link to={`${match.url}/colleges`}>
        <h4 className="moduleNavBarItem">COLLEGES</h4>
      </Link>
    </div>
    <div style={{ padding: 20 }}>
      <Switch>
        <Route path={`${match.path}/applications/:id`} component={EdlApplicationPage} />
        <Route path={`${match.path}/applications`} component={EdlAllApplications} />
        <Route path={`${match.path}/colleges/create`} component={NewEdlCollegeForm} />
        <Route path={`${match.path}/colleges`} component={EdlAllColleges} />
        <Route render={() => <Redirect to={`${match.path}/applications`} />} />
      </Switch>
    </div>
  </Fragment>
);

EducationLoansLayout.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default EducationLoansLayout;



// WEBPACK FOOTER //
// ./src/layouts/EducationLoansLayout.jsx